import { useState } from 'react'

export default function LoadConfigurator({ presets, loadVector, onChange }) {
  const [selectedPreset, setSelectedPreset] = useState('custom')
  const [fx, fy, fz] = loadVector

  const selectPreset = (preset) => {
    setSelectedPreset(preset.id)
    onChange([...preset.loadVector])
  }

  const updateComponent = (index, value) => {
    const newVector = [...loadVector]
    newVector[index] = parseFloat(value) || 0
    onChange(newVector)
    setSelectedPreset('custom')
  }

  const totalForce = Math.sqrt(fx * fx + fy * fy + fz * fz)

  return (
    <div className="bg-gray-900 rounded-lg p-4">
      <h3 className="text-sm font-semibold text-gray-300 mb-1">Applied Load</h3>
      <p className="text-[11px] text-gray-500 mb-3">What force will act on this part?</p>

      {/* Presets */}
      <div className="space-y-1 mb-3">
        {presets.map(preset => (
          <button
            key={preset.id}
            onClick={() => selectPreset(preset)}
            className={`w-full text-left p-2 rounded text-xs transition-colors ${
              selectedPreset === preset.id
                ? 'bg-blue-600/30 border border-blue-500 text-blue-300'
                : 'bg-gray-800 hover:bg-gray-750 text-gray-300 border border-transparent'
            }`}
          >
            <div className="flex justify-between items-center">
              <span className="font-medium">{preset.label}</span>
              {preset.standard && (
                <span className="text-yellow-400/70 text-[10px]">{preset.standard}</span>
              )}
            </div>
            <p className="text-gray-500 mt-0.5">{preset.desc}</p>
          </button>
        ))}
      </div>

      {/* Force vector inputs */}
      <div className="space-y-2">
        <p className="text-xs text-gray-500">Force Vector (Newtons)</p>
        <div className="grid grid-cols-3 gap-2">
          {['Fx', 'Fy', 'Fz'].map((label, i) => (
            <label key={label} className="block">
              <span className="text-xs text-gray-400">{label}</span>
              <input
                type="number"
                value={loadVector[i]}
                onChange={e => updateComponent(i, e.target.value)}
                className="w-full mt-1 bg-gray-800 border border-gray-700 rounded px-2 py-1.5 text-sm text-white focus:border-blue-500 focus:outline-none"
              />
            </label>
          ))}
        </div>
        <p className="text-xs text-gray-500">
          Total: <span className="text-white">{totalForce.toFixed(1)} N</span>
        </p>
      </div>
    </div>
  )
}
